
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import * as StatServices from '@/services/StatServices'


@Component
export default class BounceRateChart extends Vue {
    @Prop({ required: true }) from!: Date;
    @Prop({ required: true }) to!: Date;

    chartOptions = {
        chart: {
            id: 'vistors'
        },
        stroke: {
            curve: 'smooth'
        },
        xaxis: {
            type: 'datetime',
        },
        dataLabels: {
            enabled: false
        },
    }

    series = [] as any[]

    loading = false;

    @Watch('from', { immediate: true })
    @Watch('to', { immediate: true })
    async onDateChange() {
        this.loading = true;
        const data = await StatServices.GetBounceRate(this.from, this.to);

        this.series = [{
            name: 'Bounce rate',
            data: data.map((e: any) => [new Date(e.date).getTime(), e.bounceRate.toFixed(2)])
        }]
        this.loading = false;
    }
}
